import React, { ReactNode } from 'react'
import { useAppStore } from '../../stores/RootStore';
import { Button } from '@/ui/Button';
import { useNavigate } from 'react-router-dom';

type Props = {
  children: ReactNode;
  role: "editor" | "maintainer" | "root" | "admin";
  isRoute?: boolean 
};

const RoleRequire = ({ children, role, isRoute = false }: Props) => {
  const isAdmin = useAppStore((store) => store.currentUser?.attributes.admin);
  const userRole = useAppStore((store) => store.currentSite?.user_status);

  const navigate = useNavigate()

  const blockElement = isRoute ? (
    <>
      <div className="m-auto">
        <div>Нет доступа</div>
        <div>
          <Button onClick={() => navigate(-1)}>
            Вернуться назад
          </Button>
        </div>
      </div>
    </>
  ) : (
    ""
  ); // Заглушка вместо страницы, к которой нет доступа
  let element;

  switch (role) {
    case "editor":
      element = isAdmin || userRole == "editor" || userRole == "root" || userRole == "maintainer" ? children : blockElement;
      break;
    case "maintainer":
      element = isAdmin || userRole == "root" || userRole == "maintainer" ? children : blockElement;
      break;
    case "root":
      element = isAdmin ||  userRole == "root" ? children : blockElement;
      break;
    case "admin":
      element = isAdmin ? children : blockElement;
      break;
  }

  return <>{element}</>;
};

export default RoleRequire;